<script>
    import { currency_formatter } from '../../globals';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import Modal from '../elements/Modal.svelte';
    import breakpoints from "../../utils/breakpoints";
    import { push, querystring } from 'svelte-spa-router';
    import { api_host, user_store } from '../../stores';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { getFullState, formatPhoneNumber, handle_not_subscribed, deepCopy } from '../../utils/format.js';
    import { getTax, renderMainServicePriceTable, renderExtraServicePriceTable, getSubtotal, getTotalTax, isNewLayout, get_extra_service_prices } from '../../utils/tax.js';
    import { toast_message } from '../../utils/toast_message';


    const bp = breakpoints();

    let content_title = "Quote Review";
    let qid = "";
    let is_busy = false;
    let quote = {};
    let myself = {};

    // photo popup modal
    let modal_photo_popup = false;
    let selected_photo = null;

    user_store.subscribe(value => {
        myself = value;
    });

    onMount(async () => {
        const params = new URLSearchParams($querystring);

        if (params.has("qid")) {
            qid = params.get("qid");
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                `${api_host}/api/quote/get/${qid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                quote = res.quote;
                console.log('quote', quote);
            }
            else { toast_message(false, 'Fetching profile failed', 3000); }
        }
    });

    const send_quote = async () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }

        is_busy = true;
        const { auth_type, auth_token, domain_code } = getToken();
        const res = await doFetch(
            `${api_host}/api/quote/send`,
            'POST',
            { quote_id: qid },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) { 
            quote.status = 'Open';
            toast_message(true, res.msg, 3000); 
        }
        else { toast_message(false, res.msg || 'Fetching profile failed', 3000); }
        is_busy = false;
    }

    const quote_edit = () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        } else {
            push("#/Quote_Edit?qid=" + qid);
        }
    }

    const create_job = () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        } else {
            push("#/Job_Create?qid=" + qid);
        }
    }

    const showThumbnail = (photo) => {
        selected_photo = photo;
        modal_photo_popup = true;
    }

</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    {#if quote.status !== 'closed' && quote.status != 'Closed' }
    <div style="display: flex;grid-area: bh;margin-top: 15px;">
        <button class="send" on:click={() => { send_quote(); }} disabled={is_busy}>
            <i class="fas fa-mail-bulk"></i> Send Quote
        </button>
        &nbsp;&nbsp;
        <button class="reminder" on:click={() => { quote_edit(); }} disabled={is_busy}>
            <i class="fas fa-edit"></i> Update Quote
        </button>
        &nbsp;&nbsp;
        <button class="newjob" on:click={() => { create_job(); }} disabled={is_busy}>
            <i class="fas fa-plus"></i> Create Job
        </button>
    </div>
    {/if}

    <div class="section clientinfo">
        <div class="sectiontitle"><i class="fas fa-user"></i> Prospect (potential client) Information</div>

        {#if Object.keys(quote).length}
        <div class="sectioninfo">
            <div class="leftcolumn">
                <div class="infoitem">
                    <div class="infoitemtitle">Name:</div>
                    <div class="infoitemvalue">{`${quote.first_name} ${quote.last_name}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Address:</div>
                    <div class="infoitemvalue">{`${quote.address}, ${quote.city}, ${getFullState(quote.state)}`}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Email:</div>
                    <div class="infoitemvalue">{quote.email}</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Home Phone:</div>
                    <div class="infoitemvalue">{formatPhoneNumber(quote.home_phone)}</div>
                </div>
            
                <div class="infoitem">
                    <div class="infoitemtitle">Cell Phone:</div>
                    <div class="infoitemvalue">{formatPhoneNumber(quote.mobile_phone)}</div>
                </div>
            </div>
        </div>
        {/if}
    </div>
    
    <div class="section serviceinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>

        {#if Object.keys(quote).length}
        <div class="sectioninfo">
            <div class="leftcolumn">
                <div class="infoitem">
                    <div class="infoitemtitle">Quote Created Date:</div>
                    <div class="infoitemvalue">{new Date(quote.created_at).toLocaleDateString()}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service Type:</div>
                    <div class="infoitemvalue">{quote.service_type}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Service Frequency:</div>
                    <div class="infoitemvalue">{quote.service_frequency}</div>
                </div>
                {#if isNewLayout(quote)}
                <div class="infoitem">
                    <div class="infoitemtitle">Service Price:</div>
                </div>
                <div class="infoitem service-price">
                    {@html renderMainServicePriceTable(quote.service_prices)}
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Additional Comments:</div>
                </div>
                <div class="infoitem">
                    <pre style="white-space: pre-wrap; word-break: auto-phrase;">{quote.additional_comments || 'None'}</pre>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Service Price:</div>
                    {#if get_extra_service_prices(quote.service_prices).length == 0 }
                    <div class="infoitemvalue">$0.00</div>
                    {/if}
                </div>
                <div class="infoitem service-price">
                    {@html renderExtraServicePriceTable(quote.service_prices)}
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Subtotal:</div>
                    <div class="infoitemvalue">{currency_formatter.format(getSubtotal(quote.service_prices))}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Tax:</div>
                    <div class="infoitemvalue">{currency_formatter.format(getTotalTax(quote.service_prices))}</div>
                </div>
                {:else}
                <div class="infoitem">
                    <div class="infoitemtitle">Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(quote.service_price)}</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Extra Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(quote.extra_service_price)}</div>
                </div>
                {/if}
                <div class="infoitem">
                    <div class="infoitemtitle">Total Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(quote.total_service_price)}</div>
                </div>
                {#if quote.service_frequency != 'One-Time'}
                <div class="infoitem">
                    <div class="infoitemtitle">Next Service Price:</div>
                    <div class="infoitemvalue">{currency_formatter.format(quote.next_service_price)}</div>
                </div>
                {/if}
                {#if quote.service_type == 'Yard/Lawn Service'}
                <div class="infoitem">
                    <div class="infoitemtitle">Lawn:</div>
                    <div class="infoitemvalue">{quote.lawn}</div>
                </div>
                {/if}
                <div class="infoitem">
                    <div class="infoitemtitle">Internal Comments:</div>
                </div>
                <div class="infoitem">
                    <pre  style="white-space: pre-wrap; word-break: auto-phrase;">{quote.internal_comments || 'None'}</pre>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Status:</div>
                    <div class="infoitemvalue" style="text-transform: capitalize;">{quote.status}</div>
                </div>
            </div>
        </div>
        {/if}
    </div>

    {#if (quote.photos ?? []).length > 0}
    <div class="section photoinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
        <div class="sectioninfo">
            <div class="photo-list">
                {#each (quote.photos ?? []) as photo}
                <div class="photo-item" on:click="{showThumbnail(photo)}">
                    <img class="photo" src="{photo}" alt="{photo}" />
                </div>
                {/each}
            </div>
        </div>
    </div>
    {/if}

    <Modal bind:modal_show={modal_photo_popup} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600} modal_padding=15>
        <div>
            <div style="padding-bottom: 5px; font-size: 18px; font-weight: 500;">Photo</div>
            <img class="photo-thumbnail" src="{selected_photo}" alt="{selected_photo}" />
        </div>
    </Modal>
</div>

<style>
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
                            "ci ci ci ci ci ci si si si si si si"
                            "co co co co co co co co co co co co"
                            "pi pi pi pi pi pi pi pi pi pi pi pi";
                             
        gap: 15px;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 50%;
        font-weight: bold;
        text-align: left;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    :global(.progressitem.completed) {
        background-color: #a2cf6e !important;
    }

    :global(.progressitem.completed .progressitemts) {
        color: white !important;
    }
    .reminder{
        background-color: #ff9100;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
    }
    .newjob {
        background-color: #1c54b2;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
    }
    .send {
        background-color: #238718;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
    }
    .clientinfo {
        grid-area: ci;
    }
    .serviceinfo {
        grid-area: si;
    }
    .photoinfo {
        grid-area: co;
    }
    .section {
        border: 1px solid #1769aa;
    }
    .photo-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .photo-item {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
	.photo{
		height: 150px;
		width: 150px;
	}
    .photo-thumbnail {
        height: 100%;
        width: 100%;
        max-height: 600px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "bh"
                                "ci"
                                "si"
                                "co"
                                "pi";
            gap: 20px;

        }
        .infoitem {
            width: 100%;
            display: flex;
            flex-direction: row;
        }
        .infoitem .infoitemtitle {
            width: 50%;
            font-weight: bold;
            text-align: left !important;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
        }
        .infoitem .infoitemvalue {
            text-align: left;
            margin-left: 10px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
            width: 50%;
        }
    }
</style>